import { BrowserRouter, Routes, Route } from "react-router-dom"
import Navbar from "./components/Navbar"
import Auth from "./components/Auth/Auth"
import PostDetails from "./components/Posts/PostDetails"
import Contacts from "./pages/Contacts"
import HomePage from "./pages/HomePage"
import MainPosts from "./components/Posts/MainPosts"
import Footer from "./components/Footer"
import Jobs from "./pages/jobs/Jobs"
import Quiz from "./pages/quiz/Quiz"
import MainArticlePage from "./components/articles/MainArticlePage"
import { AddArticle } from "./components/articles/add/AddArticle"
import NotFoundPage from "./pages/NotFoundPage"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

function App() {
  return (
    <>
      <BrowserRouter>
        <Navbar />
        <Routes>
          {/* <Route path="/" element={<Navigate to="/posts" />} /> */}
          <Route path="/" element={<HomePage />} />
          {/* <Route path="/posts" element={<MainPosts />} /> */}
          <Route path="/posts" element={<MainArticlePage />} />
          <Route path="/posts/add" element={<AddArticle />} />
          <Route path="/posts/search" element={<MainArticlePage />} />
          <Route path="/posts/:id" element={<PostDetails />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>

        <Footer />
      </BrowserRouter>
      <ToastContainer />
    </>
  )
}

export default App
